<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">所有新闻</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="新闻动态" description="了解我们最新的动态" to="/journalism">
            <template #icon>
              <img data-src="@/home/assets/header/journalism-1.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="校源行" description="高校开源活动的最新动向" href="https://openatom.cn/journalism/index/aavyxI">
            <template #icon>
              <img data-src="@/home/assets/header/journalism-2.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="开源大赛" description="开源大赛的最新动向" href="https://openatom.cn/journalism/index/FYLvCn">
            <template #icon>
              <img data-src="@/home/assets/header/journalism-3.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">品牌资源</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="品牌使用指南" href="https://openatom.cn/brand-guide">
            <template #icon>
              <img data-src="@/home/assets/header/brand-1.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="品牌标识下载" href="https://openatom.tech/OpenAtomFoundation/brand-identity">
            <template #icon>
              <img data-src="@/home/assets/header/brand-2.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
